import { io } from 'socket.io-client';

//const url = "http://localhost:8080";
//const url = "https://staffassessor.vercel.app";
//const url = "https://staffassessor.onrender.com";
//const url = "https://assessor.up.railway.app/";
const url = process.env.VUE_APP_API_URL;

const socket = io(url, {
    transports: ["websocket", "polling"], // add polling fallback
    withCredentials: false
});

socket.on("connect", () => {
  console.log("Connected:", socket.id);
  
});

export default socket;